/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { DefaultButton, IDropdownOption, IPivotStyles, MessageBar, MessageBarType, Panel, PanelType, Persona, PersonaSize, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';

import { IAoo, IChoiceField, IField, IRuoloAoo, ITextField, IUser, IUserField } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import usersService from '../../../services/users.service';
import { RootState } from '../../../store';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import aooService from '../../../services/aoos.service';
import { AddEditUserAoo_Mode, RoleContext } from '../../../shared/enums';
import { toastRef } from '../../Layout/Layout';
import Utilities from '../../../shared/Utilities/utilities';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AddUserAoo from './AddUserAoo';
import EditUserAoo from './EditUserAoo';
import EditRouloAoo from './EditRouloAoo';


const pivotBarStyles: Partial<IPivotStyles> = {

    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const mapState = (state: RootState) => ({
    allRoles: state.sessionReducer.allRoles,
    userActiveAoo: state.sessionReducer.userActiveAoo,
    isMobile: state.sessionReducer.isMobile
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditPanelProps {
    loading?: boolean
    extraCssClass?: string
    selectedUser?: IUser
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => void
    onDismiss: () => void
    panelIsEdit: boolean

    peopleList: IUser[]
}

type Props = AddEditPanelProps & RouteComponentProps & PropsFromRedux

const AddEditPanel: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');

    useEffect(() => {

        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen);

    }, [props.panelIsOpen]);






    const onPivotItemClick = (item, ev) => {

    }

    return (
        <React.Fragment>
            <Panel
                key='addEditUsersAooManagerPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />




                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>
                        {props.panelIsEdit && props.selectedUser
                            ?
                            <div className="add-edit-panel-content col-12 flex flex-column">
                                <Persona
                                    size={PersonaSize.size32}
                                    key={props.selectedUser!.userId}
                                    imageUrl={props.selectedUser!.imageUrl}
                                    imageInitials={props.selectedUser!.initials}
                                    presence={props.selectedUser!.presence}
                                    text={props.selectedUser!.displayName}
                                    hidePersonaDetails={false}
                                    styles={{ root: { marginBottom: 16 } }}
                                />



                                <Pivot aria-label="Gestione utenze" styles={pivotBarStyles} className="flex flex-column add-edit-panel-pivot-component" onLinkClick={onPivotItemClick}>
                                    <PivotItem id="preferenze" headerText="Preferenze" className="add-edit-panel-pivot-item flex flex-column" >
                                        <div className={"col-12 flex flex-column position-relative overflow-hidden"}>
                                            <CircleLoader loaderClass='loader-large' loading={loading} />
                                            <EditUserAoo  {...props} selectedUser={props.selectedUser!} />
                                        </div>
                                    </PivotItem>
                                    <PivotItem id="ruolo" headerText="Ruolo" className="add-edit-panel-pivot-item flex flex-column" >
                                        <div className={"col-12 flex flex-column position-relative overflow-hidden"}>
                                            <CircleLoader loaderClass='loader-large' loading={loading} />
                                            <EditRouloAoo  {...props} selectedUser={props.selectedUser!} />
                                        </div>
                                    </PivotItem>

                                </Pivot>
                            </div>
                            :
                            <AddUserAoo  {...props} />
                        }
                    </div>


                </div>

            </Panel>

        </React.Fragment >

    );
}

export default connector(withRouter(AddEditPanel));
